<template>
  <div class="row justify-content-md-center">
    <div class="col-12 form-group px-4 pt-3 pb-3 pb-sm-0">
      <label class="form-control-label">Inclusão de Gerentes Comerciais</label><br>
      <div class="row justify-content-md-start">
        <div class="col-md-12">
          <base-input>
            <multiselect
              v-model="internalValue.managers"
              :options="managers"
              :multiple="true"
              :searchable="true"
              :close-on-select="false"
              :show-labels="false"
              track-by="id"
              label="name"
              placeholder="Vincular um ou mais gerentes comerciais"
              @search-change="searchManager"
              @open="emit('grow-container')"
              @close="emit('shrink-container')"
              rules="required"
            />
          </base-input>
        </div> 
      </div>
      <label class="form-control-label">Inclusão de Segmentos</label><br>
      <div class="row justify-content-md-start">
        <div class="col-md-12">
          <base-input>
            <multiselect
              v-model="internalValue.channels"
              :options="channels"
              :multiple="true"
              :close-on-select="false"
              track-by="id"
              label="description"
              placeholder="Selecione um segmento"
              :limit="1"
              :limit-text="limitText"
              rules="required"
            />
          </base-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineEmits, watch } from 'vue'
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import useModel from "@/composables/useModel";
import axios from "@/backend/axios/index.js";

const emit = defineEmits(["input", 'grow-container', 'shrink-container']);

const internalValue         = ref({});
const updatingInitialData   = ref(false)
const searchManagerTimer    = ref(null)
const managers              = ref([])

watch(internalValue, (newValue) => {
  if (updatingInitialData.value) return;

  emit("input", newValue) 
}, { deep: true });

const populateInitialData = () => {
  updatingInitialData.value = true
  internalValue.value = { ...props.initialData }
  updatingInitialData.value = false
}

onMounted(() => {
  getManagers()
  fetchChannels()
  populateInitialData()
})

const props = defineProps({
  value: { type: Object },
  initialData: { type: Object },
  anosafra: {type: Object }
})

const { fetchChannels, channels } = useModel('channel', '/api/v1/channels');

const limitText = (count) => {
  return `+ ${count}`;
};

const getManagers = async (name = null) => {
  const params =  {
    q: {
      name: name,
      is_manager: true,
      status: true
    }
  }

  if (props.anosafra) params.q.anosafra_id = props.anosafra.id


  try {
    const response = await axios.get("/api/v1/users", {
      params: params
    })
    managers.value = response.data.users
  } catch (error) {
    console.error(error)
  }
}

const searchManager = (name) => {
  if (searchManagerTimer.value) clearTimeout(searchManagerTimer.value)

  searchManagerTimer.value = setTimeout(() => {
    getManagers(name)
  }, 300)
}
</script>
<style lang="scss" scoped>
.form-group {
  background-color: #e9ecef;
  border-radius: 10px;
}

</style>
